import { useQuery } from '@tanstack/react-query';
import { useTableRequest } from '@dfl/mui-admin-layout';
import { useMemo } from 'react';
import { USERS_LIST_KEY } from 'modules/security/users/constants/queries';
import { EmptyFilter, FilterFactory, TermFilter } from '@dofleini/query-builder';
import { USER_LIST_TYPES } from 'modules/security/users/constants/list-types.constant';
import { SPACE_TYPE } from 'modules/security/users/constants/space-types.constants';
import { UserAdminService } from 'modules/security/users/services';

export const useFindUsersTable = (type: SPACE_TYPE, status: USER_LIST_TYPES, space?: string) => {
  const { statusFilter, searchFunction } = useFetchUser(type, status, space);

  const { fetch, queryKey } = useTableRequest(searchFunction, statusFilter);

  return useQuery({
    queryKey: [USERS_LIST_KEY, queryKey, type, status, space],
    queryFn: fetch,
  });
};

const useFetchUser = (type: SPACE_TYPE, status: USER_LIST_TYPES, space?: string) => {
  return useMemo(() => {
    return {
      statusFilter: getFiltersByStatus(status),
      searchFunction: getSearchFunctionByType(type, space),
    };
  }, [type, status, space]);
};

export const getFiltersByStatus = (status: USER_LIST_TYPES) => {
  switch (status) {
    case USER_LIST_TYPES.ALL: {
      return new EmptyFilter();
    }
    case USER_LIST_TYPES.ACTIVE: {
      const filter = new TermFilter({ field: 'security.lock', value: false });
      return FilterFactory.add(filter, new TermFilter({ field: 'security.verified', value: true }));
    }
    case USER_LIST_TYPES.UNVERIFY: {
      const filter = new TermFilter({ field: 'security.lock', value: false });
      return FilterFactory.add(filter, new TermFilter({ field: 'security.verified', value: false }));
    }
    case USER_LIST_TYPES.LOCK: {
      return new TermFilter({ field: 'security.lock', value: true });
    }
    case USER_LIST_TYPES.BUSINESS: {
      return new TermFilter({ field: 'types', value: 'BUSINESS' });
    }
  }
};

const getSearchFunctionByType = (type: SPACE_TYPE, space?: string) => {
  switch (type) {
    case SPACE_TYPE.ROOT: {
      return (params?: any) => UserAdminService.searchRootsUsers({ ...params, space });
    }
    case SPACE_TYPE.PROVIDER: {
      return (params?: any) => UserAdminService.searchProviderUsers({ ...params, space });
    }
    case SPACE_TYPE.PUBLIC: {
      return UserAdminService.search;
    }
  }
};
